import { render, staticRenderFns } from "./StatisticView.vue?vue&type=template&id=2500219b&scoped=true"
import script from "./StatisticView.ts?vue&type=script&lang=ts&external"
export * from "./StatisticView.ts?vue&type=script&lang=ts&external"
import style0 from "./StatisticView.scss?vue&type=style&index=0&id=2500219b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500219b",
  null
  
)

export default component.exports